var _circle, _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCDoc(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 25,
    viewBox: "0 0 25 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 12.5,
    cy: 12.5,
    r: 12.5,
    fill: "#DCF0FF"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 13.3846V11.7692C17 11.2184 16.7867 10.6901 16.4069 10.3006C16.0271 9.91113 15.5121 9.69231 14.975 9.69231H14.075C13.896 9.69231 13.7243 9.61937 13.5977 9.48954C13.4711 9.3597 13.4 9.18361 13.4 9V8.07692C13.4 7.52609 13.1867 6.99782 12.8069 6.60832C12.4271 6.21882 11.9121 6 11.375 6H10.25M11.6 6H8.675C8.3024 6 8 6.31015 8 6.69231V17.3077C8 17.6898 8.3024 18 8.675 18H16.325C16.6976 18 17 17.6898 17 17.3077V11.5385C17 10.0696 16.4311 8.66084 15.4184 7.62218C14.4057 6.58351 13.0322 6 11.6 6Z",
    stroke: "#001F3B",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCDoc);
export default __webpack_public_path__ + "static/media/c-doc.d92bf29674bd1ce8ea9b945d04dc6213.svg";
export { ForwardRef as ReactComponent };